export default __webpack_public_path__ + "static/media/DashBoard.89248eae.png";